import { Injectable } from '@angular/core'
import { HttpClient, HttpParams } from '@angular/common/http'
import { map, Observable, of, switchMap } from 'rxjs'
import { ApiService } from './api.service'
import { ContractOperator } from '../store/interfaces/contract-operator'
import { environment } from '../../environments/environment'
import { unwrapCrudList } from '../common/utils/crud-response.util'

@Injectable({ providedIn: 'root' })
export class ContractOperatorService {
  private readonly resource = 'contract-operators'
  private readonly apiBase = environment.apiUrl.endsWith('/') ? environment.apiUrl : `${environment.apiUrl}/`

  constructor(
    private readonly api: ApiService,
    private readonly http: HttpClient,
  ) {}

  getByOperatorId(operatorId: string | number): Observable<ContractOperator[]> {
    const load = (page: number): Observable<ContractOperator[]> => {
      const params = new HttpParams()
        .append('filter', `operatorId||$eq||${operatorId}`)
        .append('join', 'contract')
        .set('limit', '1000')
        .set('page', String(page))
      return this.api
        .get<ContractOperator[] | { data: ContractOperator[]; pageCount?: number }>(this.resource, params)
        .pipe(
          switchMap((response) => {
            const records = unwrapCrudList<ContractOperator>(response)
            const pageCount = Array.isArray(response) ? 1 : Number(response?.pageCount ?? 1)
            return page < pageCount ? load(page + 1).pipe(map((next) => [...records, ...next])) : of(records)
          }),
        )
    }
    return load(1)
  }

  /** HttpClient directo para conservar HttpErrorResponse.error.code en el alta. */
  create(contractId: string, operatorId: string | number): Observable<ContractOperator> {
    return this.http.post<ContractOperator>(`${this.apiBase}${this.resource}`, { contractId, operatorId })
  }

  delete(id: string | number): Observable<void> {
    return this.api.delete<void>(`${this.resource}/${id}`)
  }
}
